import { render } from "./RegionAggregatedTable.vue?vue&type=template&id=6cd4a179&scoped=true&ts=true"
import script from "./RegionAggregatedTable.vue?vue&type=script&lang=ts"
export * from "./RegionAggregatedTable.vue?vue&type=script&lang=ts"

import "./RegionAggregatedTable.vue?vue&type=style&index=0&id=6cd4a179&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cd4a179"]])

export default __exports__